import { useEffect } from "react";
import { Search } from "lucide-react";
import { X_SEARCH } from "@/lib/site";

const ACCOUNTS = [
  { handle: "elonmusk", name: "Elon Musk" },
  { handle: "SpaceX", name: "SpaceX" },
];

const SEARCHES = [
  { q: "SpaceX share every child", label: "SpaceX share every child" },
  { q: "from:elonmusk SpaceX share kids", label: "Elon Musk on SpaceX shares" },
  { q: "SpaceX shares kids 2027", label: "SpaceX shares kids 2027" },
  { q: "SpaceX shares children filter:news", label: "News outlets on X" },
];

function useWidgets() {
  useEffect(() => {
    if (window.twttr?.widgets) { window.twttr.widgets.load(); return; }
    if (document.getElementById("x-widgets")) return;
    const s = document.createElement("script");
    s.id = "x-widgets";
    s.src = "https://platform.twitter.com/widgets.js";
    s.async = true;
    document.body.appendChild(s);
  }, []);
}

export const XSearchLinks = () => (
  <div className="flex flex-wrap gap-2">
    {SEARCHES.map((s, i) => (
      <a key={s.q} href={X_SEARCH(s.q)} target="_blank" rel="noopener noreferrer" data-testid={`x-search-link-${i}`}
        className="inline-flex items-center gap-1.5 rounded-full border border-slate-700 px-3 py-1.5 text-xs text-slate-300 hover:border-[#0052FF] hover:text-white transition-colors">
        <Search className="h-3 w-3" /> {s.label}
      </a>
    ))}
  </div>
);

export const XFeed = () => {
  useWidgets();
  return (
    <div data-testid="x-feed" className="space-y-5">
      <div className="grid gap-5 md:grid-cols-2">
        {ACCOUNTS.map((a) => (
          <div key={a.handle} data-testid={`x-timeline-${a.handle.toLowerCase()}`} className="rounded-xl border border-slate-800 bg-[#121722] p-3 max-h-[560px] overflow-hidden">
            <a className="twitter-timeline" data-theme="dark" data-height="520" data-chrome="noheader nofooter transparent"
              data-dnt="true" href={`https://twitter.com/${a.handle}`}>
              <span className="block p-6 text-sm text-slate-400">
                Posts by {a.name} (@{a.handle}) — view on X →
              </span>
            </a>
          </div>
        ))}
      </div>
      <div className="rounded-xl border border-slate-800 bg-[#121722] p-5 space-y-3">
        <p className="text-sm text-slate-300">See the latest live discussion directly on X:</p>
        <XSearchLinks />
      </div>
    </div>
  );
};
